var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 /* parent div.mrtg-rates-provider-disclaimer-container */ 
__p+='\n\n';

  let {
    provider,
    className
  } = options;

__p+='\n\n<p>'+
((__t=( provider.rate_disclosure ))==null?'':__t)+
'<br/>\n</p>\n<div class="toggle-rate-disclaimer">\n  <a href="#collapse-rate-disclaimer" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse-rate-disclaimer">\n    <h3 class="'+
((__t=( className ))==null?'':__t)+
'">Advertising Disclosure</h3>\n  </a>\n</div>\n<div id="collapse-rate-disclaimer" class="collapse">\n  <div class=\'rates-provider-full-disclaimer\'>\n    <p>'+
((__t=( provider.advertising_disclosure ))==null?'':__t)+
'</p>\n    <p>Neither this website nor the data provider endorses or recommends any companies or products. Rates are subject to change without notice and may vary from branch to branch of the same company. Also, any rates and payment examples shown here typically assume a particular credit score level, which may be different from your own credit score; therefore, the rates and monthly payment amounts available to you may differ from those shown here.</p>\n    <p>Realtor.com® is a provider of information and advertising services. <a href="https://marketing.move.com/terms-of-service/#terms" target="_blank" rel="nofollow">Learn more</a></p>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_provider_disclaimer.jst.ejs